class CartRecommendations extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.slider = null;
    this.wrapper = null;
    this.slides = [];
  }

  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector('[data-recommendations]');

    if (!recommendations) return;

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendationsHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]')?.innerHTML;

        if (!recommendationsHTML) return;

        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHTML;

        this.initSlider();
      });
  }

  initSlider() {
    this.slider = this.querySelector('.swiper');
    if (!this.slider) return;

    this.wrapper = this.slider.querySelector('.swiper-wrapper');
    if (!this.wrapper) return;

    this.slides = Array.from(this.wrapper.children);
    if (!this.slides.length) return;

    this.slider.style.overflow = 'hidden';

    this.wrapper.style.display = 'flex';
    this.wrapper.style.gap = '8px';
    this.wrapper.style.transition = 'transform 0.4s ease';
    this.wrapper.style.willChange = 'transform';

    this.slides.forEach(slide => {
      slide.style.flex = '0 0 auto';
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);